import { createSlice } from "@reduxjs/toolkit";
import { fetchGsts, fetchGstById, fetchGstByDropDown, updateGst, addGst, updateStatusInGst } from "./thunk";

interface gstState {
  gstList: any[];
  rowCount: number;
  loading: boolean;
  error: any;
  selectedgst: any;
}

const initialState: gstState = {
  gstList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedgst: null,
};

const gstSlice = createSlice({
  name: "gst",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGsts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGsts.fulfilled, (state, action) => {
        state.loading = false;
        state.gstList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchGsts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch gsts";
      })
      .addCase(fetchGstById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGstById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedgst = action.payload;
      })
      .addCase(fetchGstById.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch GST by ID";
      })
      .addCase(fetchGstByDropDown.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(fetchGstByDropDown.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch GST dropdown";
      })
      .addCase(updateGst.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.gstList = state.gstList.map((gst) =>
          gst.id === action.payload.id ? action.payload : gst
        );
        state.error = null;
      })
      .addCase(updateGst.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to update gst";
      })
      .addCase(addGst.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(addGst.rejected, (state, action) => {
        state.loading = false;
        const errorPayload = action.payload as any;
        state.error = typeof errorPayload === "string" 
          ? errorPayload 
          : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to add gst";
      })
      .addCase(updateStatusInGst.fulfilled, (state, action) => {
        // if (!action.payload?.id) return;
        // state.gstList = state.gstList.map((gst) =>
        //   gst.id === action.payload.id ? action.payload : gst
        // );
      })
      .addCase(updateStatusInGst.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default gstSlice.reducer;
